import React from 'react';
import Icon from '../../../components/AppIcon';
import { Link } from 'react-router-dom';

const QuickStatsSection = () => {
  const stats = [
    {
      id: 1,
      title: "ประชากรในอำเภอ",
      value: "82,298",
      unit: "คน",
      icon: "Users",
      color: "text-accent",
      bgColor: "bg-accent/10"
    },
    {
      id: 2,
      title: "พื้นที่รับผิดชอบ",
      value: "795",
      unit: "ตร.กม.",
      icon: "MapPin",
      color: "text-secondary",
      bgColor: "bg-secondary/10"
    },
    {
      id: 3,
      title: "ตำบลในอำเภอ",
      value: "10",
      unit: "ตำบล",
      icon: "Building",
      color: "text-success",
      bgColor: "bg-success/10"
    },
    {
      id: 4,
      title: "บริการออนไลน์",
      value: "24",
      unit: "ชั่วโมง",
      icon: "Clock",
      color: "text-warning",
      bgColor: "bg-warning/10"
    },
    {
      id: 5,
      title: "ข้อมูลอำเภอเทิง",
      value: "",
      unit: "",
      icon: "InfoIcon", // use a nicer filled-style info icon name mapped below
      color: "text-primary",
      bgColor: "bg-primary/10"
    }
  ];

  // Map pretty aliases to Lucide icon names for nicer look where available
  const iconNameMap = {
    InfoIcon: 'Info',
    Population: 'Users',
    Area: 'MapPin',
    Subdistrict: 'Building',
    Online: 'Clock'
  };

  return (
    <section className="py-12 lg:py-16 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl lg:text-3xl font-bold text-foreground mb-4">
            ข้อมูลสำคัญ
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            สถิติและข้อมูลพื้นฐานของอำเภอเทิง
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {stats?.map((stat) => {
            const isDistrictInfo = stat?.title === 'ข้อมูลอำเภอเทิง';
            const Card = (
              <div
                key={stat?.id}
                className={`bg-card rounded-lg p-6 shadow-government hover:shadow-government-lg transition-government ${isDistrictInfo ? 'cursor-pointer' : ''}`}
              >
              <div className="flex items-center justify-between mb-4">
                <div className={`w-12 h-12 rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
                  <Icon name={iconNameMap[stat?.icon] || stat?.icon} size={26} className={stat?.color} strokeWidth={2.2} />
                </div>
                <div className="text-right">
                  <div className="flex items-baseline">
                    {stat?.value !== '' ? (
                      <>
                        <span className="text-2xl lg:text-3xl font-bold text-foreground">
                          {stat?.value}
                        </span>
                        <span className="text-sm text-muted-foreground ml-1">
                          {stat?.unit}
                        </span>
                      </>
                    ) : null}
                  </div>
                </div>
              </div>
              {isDistrictInfo ? (
                <h3 className="text-sm font-medium text-primary">
                  {stat?.title}
                </h3>
              ) : (
                <h3 className="text-sm font-medium text-muted-foreground">{stat?.title}</h3>
              )}
              </div>
            );
            return isDistrictInfo ? (
              <Link key={stat?.id} to="/district-info" className="block focus:outline-none focus:ring-2 focus:ring-primary/50 rounded-lg">
                {Card}
              </Link>
            ) : (
              Card
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default QuickStatsSection;